export default __webpack_public_path__ + "static/media/CRYC10.ca1a484b.png";